<template>
  <div>
    <div
      v-if="loading && !artist.id"
      class="text-xs-center my-5 pt-5"
    >
      <v-progress-circular
        :size="50"
        color="black"
        indeterminate
      />
    </div>
    <v-container
      v-else
      fluid
      grid-list-xl
      px-0
      py-2
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          sm5
          md3
        >
          <artist-info
            v-if="artist.id"
            :artist="artist"
          />
        </v-flex>
        <v-flex
          xs12
          sm7
          md9
        >
          <div class="mx-2">
            <base-card
              color="accent"
              class="pa-3 mb-3"
              style="display: flex; align-items: center"
              v-if="!artist.is_merchandise"
            >
              <strong class="text-capitalize">{{ $t('COMMON.SHOW') }}:</strong>
              <v-checkbox
                v-model="onlyForSale"
                color="primary"
                class="pa-0 ma-0 ml-3"
                hide-details
                :label="$t('SEARCH.FOR_SALE')"
                :ripple="false"
                @change="fresh()"
                ref="checkbox"
              />
            </base-card>
            <div
              v-if="loading && artist.id"
              style="display: flex; justify-content: center"
              class="py-2"
            >
              <v-progress-circular
                :size="50"
                color="black"
                indeterminate
              />
            </div>
            <masonry
              v-else
              :cols="{default: 3, 1200: 2, 960: 1}"
              :gutter="60"
            >
              <tk-artwork
                v-for="artwork in artworks.slice(0, limit)"
                :key="artwork.id"
                :artwork="artwork"
                class="mb-5"
              />
            </masonry>

            <div
              class="text-xs-center"
              v-if="hasMoreData"
            >
              <tk-btn
                type="button"
                color="primary"
                @click="fetchMore"
              >{{ $t('COMMON.MORE') }}
              </tk-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import { RepositoryFactory } from '@/services/RepositoryFactory'
import { ErrorHandler } from '@/utils/ErrorHandler'

const artworksRepo = RepositoryFactory.artworks()
const artistsRepo = RepositoryFactory.artists()
const searchRepo = RepositoryFactory.search()
const handler = new ErrorHandler()

export default {
  name: 'page-artist-single',
  props: {
    artistSlug: {
      type: String,
      required: true
    }
  },
  components: {
    ArtistInfo: () => import('./ArtistInfo.vue')
  },

  data () {
    return {
      artist: {},
      artworks: [],
      loading: true,
      limit: 15,
      onlyForSale: false
    }
  },

  mounted () {
    this.fetchArtist()
    this.fetchArtworks()
  },

  computed: {
    hasMoreData () {
      return this.limit < this.artworks.length
    }
  },

  methods: {
    async fresh () {
      this.artworks = []
      this.fetchArtworks()
    },

    async fetchArtist () {
      await handler.handle(async () => {
        this.artist = await artistsRepo.getArtist(this.artistSlug)
        this.$app.setTitle(this.artist.name)
      })
    },

    async fetchArtworks () {
      this.loading = true

      const searchOption = {
        index: 'artworks',
        locale: this.$i18n.locale,
        filters: `(artist.slug:${this.artistSlug})${this.onlyForSale ? 'AND (is_for_sale=1)' : ''}`,
        hitsPerPage: 200
      }

      await handler.handle(async () => {
        const res = await searchRepo.search(searchOption)

        const artworks = res.data.sort((a, b) => {
          if (a.orderColumn < b.orderColumn) return -1
          if (a.orderColumn > b.orderColumn) return 1
          return 0
        })

        this.artworks.push(...artworks)
      })

      this.loading = false
    },

    fetchMore () {
      this.limit = this.limit + 15
    },

  }
}
</script>
